import { createIcon } from '../shared'

const BookmarkIcon = createIcon(
  ({ color }) => (
    <path
      d="M4 4.5C4 3.96957 4.21071 3.46086 4.58579 3.08579C4.96086 2.71071 5.46957 2.5 6 2.5H18C18.5304 2.5 19.0391 2.71071 19.4142 3.08579C19.7893 3.46086 20 3.96957 20 4.5V19.63C19.9998 19.811 19.9506 19.9885 19.8575 20.1437C19.7644 20.2988 19.6309 20.4258 19.4713 20.5111C19.3117 20.5964 19.132 20.6368 18.9512 20.628C18.7705 20.6191 18.5955 20.5614 18.445 20.461L12.278 16.341C12.1957 16.286 12.099 16.2566 12 16.2566C11.901 16.2566 11.8043 16.286 11.722 16.341L5.555 20.461C5.40447 20.5614 5.22951 20.6191 5.04877 20.628C4.86802 20.6368 4.68827 20.5964 4.52868 20.5111C4.36908 20.4258 4.23561 20.2988 4.14251 20.1437C4.04941 19.9885 4.00015 19.811 4 19.63V4.5Z"
      fill={color}
    />
  ),
  '0 0 24 24',
  'BookmarkIcon',
)

export { BookmarkIcon }
